<template>
  <div class="side-bar">
    <nav class="side-menu">
      <ul class="nav">
        <li class="active">
          <a href="#" class="d-flex ts-justify-between">
            <div class="ts-flex ts-justify-start ts-mt-3">
              <i class="fa fa-home"></i>
              {{ $t('fileManager.myFiles') }}
            </div>
            <div class="ts-flex ts-justify-end">
              <b-dropdown right variant="link" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis-v fa-2x"></i>
                </template>
                <b-dropdown-item @click="createRootFolder"
                  ><i class="fas fa-folder-plus"></i>
                  {{ $t('fileManager.createRootFolder') }}</b-dropdown-item
                >
                <b-dropdown-item @click="uploadRootFolder"
                  ><i class="fas fa-folder"></i>
                  {{ $t('fileManager.uploadFolder') }}</b-dropdown-item
                >
              </b-dropdown>
            </div></a
          >
        </li>
        <li>
          <a
            v-if="data.length > 0"
            style="min-height: 74vh; max-height: 74vh;overflow-y: auto;"
          >
            <v-jstree
              :data="data"
              children-field-name="folders"
              text-field-name="name"
              ref="tree"
            >
              <template scope="_">
                <div>
                  <p
                    @contextmenu.prevent="onRightClick($event, _.vm)"
                    @click="onLeftClick(_.vm)"
                  >
                    <i
                      :class="_.vm.themeIconClasses"
                      role="presentation"
                      v-if="!_.model.loading"
                    ></i>
                    {{ _.model.name }}
                  </p>
                </div>
              </template>
            </v-jstree>
            <vue-context ref="menu">
              <li v-for="(m, i) in menus" :key="i">
                <a href="#" @click.prevent="handle_function_call(m.action_name)"
                  ><i class="ts-mr-3" :class="m.icon"></i> {{ m.name }}</a
                >
              </li>
            </vue-context>
          </a>
          <a
            style="min-height: 74vh; max-height: 74vh;overflow: auto;"
            @contextmenu.prevent="onRootRightClick"
            class="ts-flex"
            v-else
          >
            <div class="ts-mt-64 text-center">
              <h1 class="ts-font-bold ts-text-blue-300">
                Create Your First folder
              </h1>
              <p class="ts-text-xs ts-text-gray-400">
                Right click to create or upload folder.
              </p>
            </div>
            <vue-context ref="root_menu">
              <li v-for="(m, i) in rootMenus" :key="i">
                <a href="#" @click.prevent="handle_function_call(m.action_name)"
                  ><i class="ts-mr-3" :class="m.icon"></i> {{ m.name }}</a
                >
              </li>
            </vue-context>
          </a>
        </li>
      </ul>
    </nav>
    <a-modal
      v-model="create_folder_show"
      :title="$t('fileManager.createFolder')"
      @cancel="() => (create_folder_show = false)"
      width="20%"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
    >
      <!-- @created="addFolderTree" -->
      <create-folder-component
        :data="{ id: currentId }"
        @close="() => (create_folder_show = false)"
      />
    </a-modal>
    <a-modal
      v-model="create_root_folder_show"
      :title="$t('fileManager.createRootFolder')"
      @cancel="() => (create_root_folder_show = false)"
      width="20%"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
    >
      <!-- @created="addFolderTree" -->
      <create-folder-component
        :data="{ id: null }"
        @close="() => (create_root_folder_show = false)"
      />
    </a-modal>
  </div>
</template>
<script>
import VueContext from 'vue-context'
import CreateFolderComponent from './create-folder.vue'
import UploadFileComponent from './upload-files-popup.vue'
import VJstree from 'vue-jstree'
import { mapState } from 'vuex'
import { includes, isEmpty } from 'lodash'
export default {
  name: 'folderTree',
  props: ['data'],
  components: {
    VJstree,
    VueContext,
    CreateFolderComponent
  },
  data () {
    return {
      model: {},
      menu: [
        {
          name: 'Upload Files',
          action_name: 'uploadFile',
          icon: 'fas fa-file-upload',
          is_directory: true,
          display_root: false
        },
        {
          name: 'Create Folder',
          action_name: 'createFolder',
          icon: 'fas fa-folder-plus',
          is_directory: true,
          display_root: true
        },
        {
          name: 'Upload Folder',
          action_name: 'uploadFolder',
          icon: 'fas fa-folder',
          is_directory: true,
          display_root: true
        },
        {
          name: 'Rename',
          action_name: 'rename',
          icon: 'fas fa-pencil-alt',
          is_directory: true,
          display_root: false
        },
        {
          name: 'Delete',
          action_name: 'delete',
          icon: 'fas fa-trash',
          is_directory: true,
          display_root: false
        },
        {
          name: 'Download',
          action_name: 'download',
          icon: 'fas fa-download',
          is_directory: true,
          display_root: false
        }
      ],
      create_folder_show: false,
      create_root_folder_show: false,
      fileIdx: 0,
      searchText: '',
      currentNode: null,
      itemEvents: {
        mouseover: function () {
          // console.log('mouseover')
        }
      }
    }
  },
  computed: {
    ...mapState('fileManager/fileBrowser', [
      'currentFolder',
      'currentFolderId',
      'createNewFolderStatus'
    ]),
    isTreeRender () {
      return this.data.length > 0
    },
    rootMenus () {
      return this.menu.filter(e => e.display_root == true)
    },
    menus () {
      return this.menu
    },
    currentId () {
      return isEmpty(this.model) ? null : this.model.id
    }
  },
  methods: {
    handle_function_call (function_name) {
      this[function_name]()
    },
    onRightClick (e, node) {
      this.$refs.menu.open(e, node.model)
      this.currentNode = node
      this.model = node.model
    },
    onLeftClick (node) {
      this.currentNode = node
      this.model = node.model
      this.$store.commit(
        'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
        node.model.id
      )
      this.$router.push({
        name: 'file-manager-folder',
        params: { id: node.model.id }
      })
    },
    uploadFile () {
      this.$modal.show(
        UploadFileComponent,
        {
          data: this.model
        },
        {
          height: 'auto',
          width: '800px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    uploadFolder () {
      this.$toasted.info('Under Construction!')
    },
    createFolder () {
      this.create_folder_show = true
    },
    createRootFolder () {
      this.create_root_folder_show = true
    },
    rename () {
      this.$toasted.info('Under Construction!')
    },
    async delete () {
      if (
        await this.$confirmModal.danger(
          'Are you sure to delete ' + this.model.name + '?'
        )
      ) {
        this.removing = true
        this.$store
          .dispatch('fileManager/fileFunction/deleteItem', {
            items: [
              {
                force_delete: this.model.items > 0 ? true : false,
                id: this.model.id,
                type: 'folder'
              }
            ]
          })
          .then(() => {
            this.removeNode(this.currentNode)
            if (this.model.parent_id) {
              this.$store.commit(
                'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
                this.model.parent_id
              )
              this.$router.push({
                name: 'file-manager-folder',
                params: { id: this.model.parent_id }
              })
            } else {
              this.$store.commit(
                'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
                null
              )
              this.$router.push('/file-managers')
            }
            this.getCurrentFolder()
          })
          .finally(() => {
            this.removing = false
          })
      }
    },
    download () {
      this.$toasted.info('Under Construction!')
    },
    addFolderTree () {
      let newItemData = {
        id: this.currentFolder.id,
        name: this.currentFolder.attributes.name,
        value: this.currentFolder.attributes.name,
        icon: '',
        opened: false,
        selected: true,
        disabled: false,
        loading: false,
        folders: [],
        is_directory: true
      }
      this.addNode(
        this.currentFolder.relationships.parent ? this.currentNode : null,
        newItemData
      )
      this.openedCurrentNode(this.currentFolder.id)
    },
    uploadRootFolder () {
      this.$toasted.info('Under Construction!')
    },
    addNode: function (node, newItemData) {
      if (node) {
        newItemData.selected = true
        let item = node.model
        item.opened = true
        item.addChild(newItemData)
      }
      if (!node) {
        this.$emit('fetchNavi')
      }
    },
    openedCurrentNode: function (currentFolderId) {
      this.$nextTick(() => {
        let parentId = []
        if (this.$refs.tree) {
          this.$refs.tree.handleRecursionNodeChilds(this.$refs.tree, node => {
            if (currentFolderId !== '' && node.model !== undefined) {
              let item = node.model
              item.selected = false // deselect all node
              parentId = this.getAncestors(currentFolderId, this.data)
              //opened node of current selected folders
              if (item.id === currentFolderId) {
                this.currentNode = node
                let item = node.model
                item.selected = true
                item.opened = true
              }
              //opened node of parents folders
              if (includes(parentId, item.id)) {
                let item = node.model
                item.opened = true
              }
            }
          })
        }
      })
    },
    getAncestors (target, children, ancestors = []) {
      for (let node of children) {
        if (node.id === target) {
          return ancestors.concat(node.id)
        }
        const found = this.getAncestors(
          target,
          node.folders,
          ancestors.concat(node.id)
        )
        if (found) {
          return found
        }
      }
      return undefined
    },
    onRootRightClick (e) {
      this.$refs.root_menu.open(e)
    },
    removeNode: function (node) {
      if (node !== undefined) {
        let item = node.model
        if (item.id !== undefined) {
          let index = node.parentItem.indexOf(item)
          node.parentItem.splice(index, 1)
        }
      }
    },
    getCurrentFolder () {
      this.loading = true
      this.$store
        .dispatch('fileManager/fileBrowser/getFolder', this.currentFolderId)
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    isTreeRender: {
      handler (val) {
        if (val && !isEmpty(this.$route.params)) {
          this.openedCurrentNode(parseInt(this.$route.params.id))
        }
      },
      immediate: true
    },
    currentFolderId: function (val) {
      if (val && this.isTreeRender) {
        this.openedCurrentNode(val)
      }
    },
    createNewFolderStatus: function (val) {
      if (val) {
        this.addFolderTree()
      }
    }
  }
}
</script>
